import React from "react";
import Home from './components/Home.js'

import './App.css'

const app=()=>{
  return (
    <div>
      <Home/>
    </div>
  )
}
export default app